import React from 'react'

import { BuyerIntentLeadClick, normalizeBuyerIntentId, warnMissingBuyerIntentIds } from 'components/BuyerIntent'
import ClickoutWrapper from 'components/ClickoutWrapper'
import CtaButton from 'components/CtaButton'
import Icon from 'components/Icon'
import { useEventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import PricingDisplay from '../PricingDisplay'

import classes from './CtaActions.module.scss'

/** @type {import("./types").default} */
const CtaActions = ({ listing, hasDemoForm, onShowPricingModal, listingPosition = 0 }) => {
  const { up } = useViewport()
  const { addEvent } = useEventContext({
    engagementComponent: 'best-products_list',
  })

  const isDesktop = up('lg')
  const isTablet = up('sm') && !isDesktop
  const isMobile = !isTablet && !isDesktop

  const onClickPricing = () => onShowPricingModal({ pGuid: listing.global_product_id })
  const buyerIntentProductId = normalizeBuyerIntentId(listing.global_product_id)

  if (hasDemoForm && !listing.is_premium && !buyerIntentProductId) {
    warnMissingBuyerIntentIds('top10/cta:get-price', {
      productId: listing.global_product_id,
    })
  }

  return (
    <>
      {isTablet && <PricingDisplay pricing={listing.pricing} />}

      {hasDemoForm && !listing.is_premium ? (
        !buyerIntentProductId ? (
          <CtaButton
            data-testid="listing-item_main_cta"
            className={classes.button}
            fullWidth={!isDesktop}
            variant={isMobile ? 'text' : 'contained'}
            onClick={onClickPricing}
            {...addEvent({
              engagementDetails: 'button_get_price',
              engagementDestination: 'go-to_ppl-price-form',
              name: 'engagement_product_click',
            })}
          >
            get price
          </CtaButton>
        ) : (
          <BuyerIntentLeadClick productId={buyerIntentProductId} sourceLocation="top10/cta:get-price">
            <CtaButton
              data-testid="listing-item_main_cta"
              className={classes.button}
              fullWidth={!isDesktop}
              variant={isMobile ? 'text' : 'contained'}
              onClick={onClickPricing}
              {...addEvent({
                engagementDetails: 'button_get_price',
                engagementDestination: 'go-to_ppl-price-form',
                name: 'engagement_product_click',
              })}
            >
              get price
            </CtaButton>
          </BuyerIntentLeadClick>
        )
      ) : (
        <ClickoutWrapper
          url={listing.cta_urls.cta}
          isClickout={listing.is_premium}
          listingPosition={listingPosition}
          buyerIntentProductId={buyerIntentProductId}
          buyerIntentSourceLocation="top10/cta:visit-website"
          buyerIntentTrackAdClick={listing.is_premium}
          {...addEvent(
            listing.is_premium
              ? {
                  productClickPosition: listingPosition,
                  engagementDetails: 'button_visit-website',
                  engagementDestination: 'go-to_vendor-website',
                  name: 'engagement_product_clickout',
                }
              : {
                  engagementDetails: 'button_learn-more',
                  engagementDestination: 'go-to_product_details',
                  name: 'engagement_product_click',
                }
          )}
        >
          <CtaButton
            data-testid="listing-item_main_cta"
            component="span"
            className={classes.button}
            fullWidth={!isDesktop}
            variant={isMobile ? 'text' : 'contained'}
          >
            {listing.is_premium ? 'visit website ' : 'learn more'}
            {listing.is_premium && <Icon icon={['far', 'external-link']} size="14" />}
          </CtaButton>
        </ClickoutWrapper>
      )}
    </>
  )
}

export default CtaActions
